<div
  *ngIf="isLoading | async"
  class="overlay">
  <div class="loader-container">
    <div class="spinner"></div>
    <p class="loader-text">Loading...</p>
  </div>
</div>
